import { defineMessages } from 'react-intl';

export default defineMessages({
    setPaperLessTitle:{
        id: 'policy.common.directives.paperless.setPaperLessTitle',
        defaultMessage: 'Document Distribution Notice'
    },
    optOut:{
        id: 'policy.common.directives.paperless.optOut',
        defaultMessage: 'Opt-out of Electronic Delivery'
    },
    agree:{
        id: 'policy.common.directives.paperless.agree',
        defaultMessage: 'I Agree to Electronic Delivery'
    },
    consentTitle:{
        id: 'policy.common.directives.paperless.consentTitle',
        defaultMessage: 'I consent to Electronic Delivery:'
    },
    consentDescription:{
        id: 'policy.common.directives.paperless.consentDescription',
        defaultMessage: 'To serve you better, your policies will be moved to electronic delivery. You agree that Heartland Mutual Insurance may deliver all policy declaration documents, invoices, other documents and communications related to your policy by electronic means. Should your email address change you are to provide the updated information, to continue receiving communication regarding your policies.'
    }
});
